(function () {
    let observers = []; // keep references to disconnect later

    function initInstagramTranslator() {
        const runOnPaths = [
            '/fr/pages/shop-our-instagram',
            '/fr',
        ];

        const path = window.location.pathname;
        const isAllowed = runOnPaths.some(p => path.startsWith(p));
        if (!isAllowed) {
            console.log(`Translator: skipping on ${path}`);
            return;
        }

        const monthMap = {
            JANUARY: 'JANVIER',
            FEBRUARY: 'FÉVRIER',
            MARCH: 'MARS',
            APRIL: 'AVRIL',
            MAY: 'MAI',
            JUNE: 'JUIN',
            JULY: 'JUILLET',
            AUGUST: 'AOÛT',
            SEPTEMBER: 'SEPTEMBRE',
            OCTOBER: 'OCTOBRE',
            NOVEMBER: 'NOVEMBRE',
            DECEMBER: 'DÉCEMBRE'
        };

        const selectorsToTranslate = [
            ".fs-entry-title",
            ".fs-hover-product-name",
            ".fs-detail-container .fs-product-name",
            ".fs-detail-container .fs-shopify-add-cart",
            ".fs-detail-container .fs-detail-title",
            ".fs-detail-container .fs-overlink-product-name"
        ].join(", ");

        const customOverrides = {
            // 'autumnal baby': 'bébé automnal',
        };

        async function batchTranslate(values, src = "en", tgt = "fr") {
            const joined = values.join("\n");
            const url = `https://translate.googleapis.com/translate_a/single`
                + `?client=gtx&sl=${src}&tl=${tgt}&dt=t&q=${encodeURIComponent(joined)}`;
            try {
                const res = await fetch(url);
                const data = await res.json();
                return data[0].map(chunk => chunk[0]);
            } catch (e) {
                console.error("Batch translate failed:", e);
                return values;
            }
        }

        async function handleMutations() {
            // --- Month translation ---
            document.querySelectorAll('.fs-detail-date').forEach(el => {
                if (el.dataset.monthReplaced) return;
                let txt = el.textContent.trim().toUpperCase();
                Object.entries(monthMap).forEach(([eng, fr]) => {
                    txt = txt.replace(new RegExp(`\\b${eng}\\b`, 'g'), fr);
                });
                el.textContent = txt;
                el.dataset.monthReplaced = 'true';
            });

            // --- Text translation ---
            const els = Array.from(document.querySelectorAll(selectorsToTranslate))
                .filter(el => !el.dataset.translated);
            if (els.length === 0) return;

            const unique = [...new Set(els.map(el => el.textContent.trim()))];
            const translated = await batchTranslate(unique, "en", "fr");

            const map = {};
            unique.forEach((eng, i) => {
                let fr = translated[i];
                if (customOverrides[eng]) fr = customOverrides[eng];
                map[eng] = fr;
            });

            els.forEach(el => {
                const before = el.textContent.trim();
                const after = map[before] || before;
                el.textContent = after;
                el.dataset.translated = "true";
            });
        }

        function applyObservers() {
            // Disconnect previous observers
            observers.forEach(obs => obs.disconnect());
            observers = [];

            const targets = [
                document.querySelector(".shopify-section > .page-content"),
                document.querySelector(".fs-prepended-detail.fs-wrapper")
            ].filter(Boolean);

            targets.forEach(target => {
                const obs = new MutationObserver(handleMutations);
                obs.observe(target, { childList: true, subtree: true });
                observers.push(obs);
            });

            // Run once initially
            handleMutations();
        }

        applyObservers();

        // Inject CSS once
        if (!document.getElementById('fs-translation-style')) {
            const style = document.createElement('style');
            style.id = 'fs-translation-style';
            style.textContent = `
        .fs-has-links::after {
          content: "ACHETEZ-LE" !important;
        }
      `;
            document.head.appendChild(style);
        }
    }

    // --- Run now or after DOM ready ---
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initInstagramTranslator);
    } else {
        initInstagramTranslator();
    }

    // --- Safe re-init on Shopify section reload ---
    document.addEventListener('shopify:section:load', initInstagramTranslator);
})();
